<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgements">
<p style=" font-family:Calisto MT; text-align: center; font-weight:bold; font-size:18pt; letter-spacing:1px; padding-top:90px; padding-bottom:20px;">Acknowledgements</p>
<p style="text-indent:0px">My mum, dad, grandparents Nephew Oliver, to my numerous friends in the Martial Arts, orchid growers, entomologists, wildlife conservationists and my work colleagues past and present, and to all my wonderful pets, to PDSA, WWF, BBONT, RSPB, RHS, Orchid Society of Great Britain, Hardy Orchid Society, Marie Curie, NSPCC, War Veterans organisations and to all the animal sanctuaries of the world. Pets at Home, Buckingham Nursery, Phasmid Study Group.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?1bd12547